<template>
  <div class="dashboard__view merchant-list">
    <div class="page">
            <div class="page__title"></div>
      <div class="page__title__action d-flex">
        <router-link class="btn btn--primary" to="/dashboard/statements/create-single"
          >Create Statement Record</router-link
        >
        <button
          :disabled="exportDisabled || false"
          @click="exportData"
          class="btn btn--sm btn--flex btn-filter ml__20"
          v-if="statementList.length > 0"
        >
          <div class="btn--text" v-if="exportDisabled || false">
            Exporting...
          </div>
          <div class="btn--text" v-else>Export</div>
          <span class="btn--icon">
            {{ " " }} &nbsp;
            <svg
              fill="none"
              height="12"
              viewBox="0 0 14 18"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.25 0V12.4219L2.28906 8.46094L1.21094 9.53906L6.46094 14.7891L7 15.3047L7.53906 14.7891L12.7891 9.53906L11.7109 8.46094L7.75 12.4219V0H6.25ZM0.25 16.5V18H13.75V16.5H0.25Z"
                fill="#e00b5b"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>

    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <div class="tab__content__top__left">
            {{ pageInfo.total }} Uploads
          </div>
        </div>

        <EmptyState v-if="emptyState" type="not-found" icon="transaction" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>BATCH ID</th>
                <th>BANK</th>
                <th>ROW COUNT</th>
                <th>UPLOADED DATE</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr :key="key" v-for="(item, key) in statementList">
                <td>
                  {{ item.batch_code }}
                </td>
                <td>
                  {{ item.bank_name }}
                </td>
                <td>{{ item.row_count }}</td>
                <td>{{ item.uploaded_date | date }}</td>
                <td class="act">
                  <svg
                    width="19"
                    height="21"
                    viewBox="0 0 19 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    @click="deleteRecord(item.batch_code)"
                  >
                    <path
                      d="M9.25 6.97518e-09C10.0801 -5.43467e-05 10.8788 0.317554 11.4822 0.887672C12.0856 1.45779 12.448 2.23719 12.495 3.066L12.5 3.25H17.75C17.94 3.25006 18.1229 3.32224 18.2618 3.45197C18.4006 3.5817 18.4851 3.7593 18.498 3.94888C18.511 4.13846 18.4515 4.32589 18.3316 4.4733C18.2117 4.62071 18.0402 4.7171 17.852 4.743L17.75 4.75H16.954L15.674 17.77C15.6099 18.4191 15.3171 19.0243 14.848 19.4775C14.3789 19.9306 13.7639 20.2023 13.113 20.244L12.937 20.25H5.563C4.91046 20.25 4.27919 20.0179 3.78201 19.5953C3.28482 19.1727 2.95412 18.587 2.849 17.943L2.826 17.769L1.545 4.75H0.75C0.568762 4.74999 0.393658 4.68436 0.257069 4.56523C0.120481 4.44611 0.0316483 4.28155 0.00699997 4.102L0 4C7.6429e-06 3.81876 0.0656426 3.64366 0.184767 3.50707C0.303891 3.37048 0.468446 3.28165 0.648 3.257L0.75 3.25H6C6 2.38805 6.34241 1.5614 6.9519 0.951903C7.5614 0.34241 8.38805 6.97518e-09 9.25 6.97518e-09ZM15.447 4.75H3.052L4.319 17.622C4.34705 17.9092 4.47362 18.1779 4.67722 18.3824C4.88082 18.5869 5.14892 18.7147 5.436 18.744L5.563 18.75H12.937C13.537 18.75 14.046 18.325 14.162 17.748L14.182 17.622L15.446 4.75H15.447ZM11 7.5C11.1812 7.50001 11.3563 7.56564 11.4929 7.68477C11.6295 7.80389 11.7184 7.96845 11.743 8.148L11.75 8.25V15.25C11.7499 15.44 11.6778 15.6229 11.548 15.7618C11.4183 15.9006 11.2407 15.9851 11.0511 15.998C10.8615 16.011 10.6741 15.9515 10.5267 15.8316C10.3793 15.7117 10.2829 15.5402 10.257 15.352L10.25 15.25V8.25C10.25 8.05109 10.329 7.86032 10.4697 7.71967C10.6103 7.57902 10.8011 7.5 11 7.5ZM7.5 7.5C7.68124 7.50001 7.85634 7.56564 7.99293 7.68477C8.12952 7.80389 8.21835 7.96845 8.243 8.148L8.25 8.25V15.25C8.24994 15.44 8.17776 15.6229 8.04803 15.7618C7.9183 15.9006 7.7407 15.9851 7.55112 15.998C7.36154 16.011 7.17411 15.9515 7.0267 15.8316C6.87929 15.7117 6.7829 15.5402 6.757 15.352L6.75 15.25V8.25C6.75 8.05109 6.82902 7.86032 6.96967 7.71967C7.11032 7.57902 7.30109 7.5 7.5 7.5ZM9.25 1.5C8.81081 1.50002 8.38768 1.66517 8.06461 1.96268C7.74154 2.26019 7.54214 2.6683 7.506 3.106L7.5 3.25H11C11 2.78587 10.8156 2.34075 10.4874 2.01256C10.1592 1.68437 9.71413 1.5 9.25 1.5Z"
                      fill="#e00b5b"
                    />
                  </svg>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="table__details"
            v-if="loading !== true && emptyState !== true"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Pagination from "@/components/pagination.vue";
import Vue from "vue";
import EmptyState from "@/components/empty-state.vue";
import StatusIndicatorWithWordsV2 from "../../../components/statusIndicatorWithWordsV2";
export default {
  components: {
    StatusIndicatorWithWordsV2,
    Datepicker,
    Pagination,
    EmptyState
  },
  metaInfo: {
    title: "Statement Upload History"
  },
  data() {
    return {
      statementList: [],
      pageInfo: "",
      perPage: 10,
      disabled: false,
      loading: true,
      emptyState: false,
      exportDisabled: false
    };
  },

  created() {
    this.fetchStatements();
  },

  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchStatements"
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails;
    },
  },
  methods: {
    generatePaginationLink(pageNum) {
      return {
        path: "/dashboard/statements",
        query: {
          ...this.$route.query,
          page: pageNum
        }
      };
    },
    returnQuery() {
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }
      return generatedQuery;
    },
    async fetchStatements() {
      // Convert object to multiple arrays with name and value
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      let appendedQuery = "";
      // Loop through arrays and generate the query string
      for (const [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }

      // check for mode to append query

      if (this.mode) {
          appendedQuery = "&ignore_admin_flag=1";
      } else {
          appendedQuery = "&ignore_admin_flag=1&is_test=1";
      }

      this.$http
        .get(`admin/statement/history?${generatedQuery}${appendedQuery}`)
        .then(response => {
          if (response.body.data.bank_statement.length > 0) {
            this.statementList = response.body.data.bank_statement;
            this.pageInfo = response.body.data.page_info;
            this.emptyState = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.emptyState = true;
          }
        })
        .catch(error => {
          // LOG Error
          this.loading = false;
        });
    },
    exportData() {
      this.exportDisabled = true;
      let generatedQuery = this.returnQuery();
      let url = process.env.VUE_APP_API_URL;
      const token = this.userDetails.token;
      url = `${url}/admin/statement/history?download=true&${generatedQuery}token=${token}`;
      window.open(url);
      setTimeout(() => {
        this.exportDisabled = false;
        this.$notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Success",
          text: "Exporting in progress please wait..",
        });
      }, 3000);
    },
    pollDownload(identifier) {
      this.$http.get(`dashboard/downloads/${identifier}`).then((response) => {
        // if data is available stop polling
        this.exportDisabled = false;
        clearInterval(this.polling);
        window.location.assign(response.body.data.file_url);
      });
    },

    resetState() {
      this.fullName.empty = false;
      this.businessName.empty = false;
      this.mobileNumber.empty = false;
      this.businessNuban.empty = false;
      this.password.empty = false;
      this.emailAddress.empty = false;
    },
    clearData() {
      this.fullName.value = "";
      this.businessName.value = "";
      this.mobileNumber.value = "";
      this.businessNuban.value = "";
      this.password.value = "";
      this.emailAddress.value = "";
    },

    async deleteRecord(code){
      this.loading = true;
     const [res, e] =  await this.$store.dispatch("deleteStatement", code )
     if (res){
       await this.fetchStatements();
       this.$store.dispatch("notify", {
          s: res,
          str: "Record deleted successfully."
        });
     } else{
        this.$store.dispatch("notify", {
          e,
          str: "Could not delete the record. Please try again."
        });
     }
     this.loading = false
    }
  }
};
</script>

<style lang="scss" scoped>
.merchant-list {
  .create-merchant-btn {
    position: absolute;
    right: 20px;
    top: 10px;
  }
  .dropdown-item-list {
    display: flex;
    align-items: center;
    span {
      display: inline;
      padding-left: 10px;
    }
  }
  .pending {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #b59b00;
  }
  .name {
    color: #261940;
    display: block;
    margin-bottom: 4px;
  }

  .email {
    color: rgba(38, 25, 64, 0.6);
    font-size: 12px;
  }

  .page__link {
    color: rgba(38, 25, 64, 0.6);
    font-size: 14px;
    line-height: 20px;
    padding: 12px 24px;
    text-decoration: none;
    display: block;
    &:hover {
      color: #e00b5b;
    }
  }
}
.text-green {
  color: #29d450 !important;
}

.ml__20 {
  margin-left: 20px;
}

.brand__text-color {
  color: #ff7176;
}

.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;

  span {
    color: #e00b5b;
    cursor: pointer;
  }
}

.mt__10 {
  margin-top: 10px;
}

.cr-pointer {
  cursor: pointer;
}

.page {
  align-items: flex-end !important;
}
</style>
